'use client';
import { useTranslations } from 'next-intl';
import { BaseLinePlus } from '@/app/components/icons/BaseLinePlus';

interface CreateCardProps {
  onClick?: () => void;
}

// 创建新项目卡片组件
export const CreateCard = ({ onClick }: CreateCardProps) => {
  const t = useTranslations();
  return (
    <div
      onClick={onClick}
      className="flex h-[136px] w-60 cursor-pointer flex-col items-center justify-center gap-1 rounded-2xl border border-system-white08 bg-system-white04 backdrop-blur-sm transition-all hover:border-system-white16 hover:bg-system-white04"
    >
      <BaseLinePlus className="size-6 text-system" />
      <span className="text-system-white64 text-xs">{t('agentProject.create')}</span>
    </div>
  );
};
